// extracted by mini-css-extract-plugin
export var component = "NoticeModule-module--component--n9OsX";
export var content = "NoticeModule-module--content--vPrjy";
export var hasIcon = "NoticeModule-module--hasIcon--YSv1h";
export var icon = "NoticeModule-module--icon--qWl1O";
export var title = "NoticeModule-module--title--4J3Um";